import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Brand from "@/components/Brand";
import { SignOut } from "@phosphor-icons/react";

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const loc = useLocation();

  const nav_items = [];
  if (user?.role === "admin" || user?.role === "superadmin") {
    nav_items.push({ to: "/dashboard", label: "Dashboard" });
  }
  if (user?.role === "team_owner") {
    nav_items.push({ to: "/team", label: "My Team" });
  }
  if (user?.role === "superadmin") {
    nav_items.push({ to: "/superadmin", label: "Platform" });
  }

  const doLogout = async () => { await logout(); };

  return (
    <div className="min-h-screen flex flex-col text-slate-900" style={{ fontFamily: "Inter, sans-serif", background: "#EEF2F6" }}>
      <header className="border-b border-gray-200 bg-white/95 backdrop-blur sticky top-0 z-30 shadow-sm">
        <div className="max-w-[1500px] mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between gap-3">
          <Brand size="sm" showTag={false} />
          <nav className="hidden md:flex items-center gap-1" data-testid="main-nav">
            {nav_items.map(({ to, label }) => {
              const active = loc.pathname === to || (to !== "/" && loc.pathname.startsWith(to));
              return (
                <Link
                  key={to}
                  to={to}
                  data-testid={`nav-${label.toLowerCase().replace(/\s+/g, "-")}`}
                  className={`px-4 py-2 text-xs font-bold tracking-widest uppercase rounded transition-colors ${
                    active ? "bg-blue-50 text-blue-700" : "text-gray-600 hover:text-blue-600 hover:bg-gray-100"
                  }`}
                >
                  {label}
                </Link>
              );
            })}
          </nav>
          <div className="flex items-center gap-2">
            {user ? (
              <>
                <div className="text-right hidden sm:block">
                  <div className="text-sm font-semibold truncate max-w-[140px] text-slate-900">{user.name}</div>
                  <div className="label-mono">{user.role}</div>
                </div>
                <button onClick={doLogout} data-testid="logout-button" className="btn-ghost !px-3 !py-2 text-xs flex items-center gap-2">
                  <SignOut size={14} /> <span className="hidden sm:inline">Logout</span>
                </button>
              </>
            ) : (
              <>
                <Link to="/login" data-testid="header-login-link" className="btn-ghost !px-3 !py-2 text-xs">Sign in</Link>
                <Link to="/register" data-testid="header-register-link" className="btn-primary !px-3 !py-2 text-xs">Get started</Link>
              </>
            )}
          </div>
        </div>
        <div className="md:hidden border-t border-gray-200 overflow-x-auto">
          <div className="flex px-3 gap-1">
            {nav_items.map(({ to, label }) => {
              const active = loc.pathname === to || (to !== "/" && loc.pathname.startsWith(to));
              return (
                <Link key={to} to={to} className={`px-3 py-2 text-[11px] font-bold tracking-widest uppercase whitespace-nowrap ${active ? "text-blue-700 border-b-2 border-blue-600" : "text-gray-500"}`}>
                  {label}
                </Link>
              );
            })}
          </div>
        </div>
      </header>

      <main className="flex-1 max-w-[1500px] w-full mx-auto px-4 sm:px-6 py-6 sm:py-8 relative z-10">{children}</main>

      <footer className="border-t border-gray-200 bg-white py-5 relative z-10 mt-auto">
        <div className="max-w-[1500px] mx-auto px-6 label-mono text-center">
          © NitiSoft Technologies · Cricket Auction Platform
        </div>
      </footer>
    </div>
  );
}
